import Crud from '@/views/Logs/Crud'

const routes = {
  path: '/activity-logs',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/activity-logs',
      name: 'list-activity-logs',
      component: Crud,
      meta: {
        pageTitle: 'Logs de Atividade',
        is_admin: [1, '1'],
        breadcrumb: [
          {
            text: 'Logs de Atividade',
            active: true,
          },
        ],
      },
    },
  ],
}

export default routes
